import script from "./BoardApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardApp.vue?vue&type=script&setup=true&lang=ts"

import "./BoardApp.vue?vue&type=style&index=0&id=c31dcd70&scoped=true&lang=css"
import "./BoardApp.vue?vue&type=style&index=1&id=c31dcd70&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c31dcd70"],['__file',"BoardApp.vue"]])

export default __exports__